module.exports = __webpack_public_path__ + "media/img/illustrations/plus@1.5x-abeef06abe0bf4552ae237e73ed622da.svg";